import React from "react";
import "./styles.css";
import { useAuth } from "@BUP/hooks";
import { Button, notification } from "antd";
import firebase from "firebase/app";
import "firebase/auth";

export const UserProfile = () => {
  const { user } = useAuth();

  const auth = firebase.auth();

  const resetPassword = (email) => {
    auth
      .sendPasswordResetEmail(email)
      .then(function () {
        notification["info"]({
          style: { fontWeight: 500, fontSize: 17 },
          message: "¡Mensaje Enviado!",
          description: `Se ha enviado un mensaje a ${user.email} para restablecer tu contraseña`,
          duration: 20,
        });
      })
      .catch(function (error) {});
  };

  return (
    <div className="profile-page">
      <div className="profile-user-information">
        <ul>
          <li>
            <strong>Nombre:</strong> {user?.name || " "}.
          </li>
          <li>
            <strong>Correo Electronico:</strong> {user?.email || " "}.
          </li>
          <li>
            <strong>Establecimiento:</strong> {user?.organizations?.name || " "}
            .
          </li>
          <li>
            <strong>Estamento:</strong> {user?.roles?.name || " "}.
          </li>

          <li>
            <strong>Cursos:</strong> {user?.courses?.name || "Todos los cursos"}
            .
          </li>
        </ul>
        <Button
          shape="round"
          type="primary"
          onClick={() => resetPassword(user.email)}
        >
          Cambiar contraseña
        </Button>
      </div>

      <div className="profile-footer">
        <p>
          Si eres parte de otro estamento de la comunidad o tus datos son
          erroneos acercate a hablar con el equipo de convivencia para que te
          ayudemos a editar tu perfil.
        </p>
      </div>
    </div>
  );
};
